import { graphql } from "@/gql";

export const flushMeilisearchMutation = graphql(`
  mutation FlushMeilisearch($modelClass: String!) {
    flushMeilisearch(modelClass: $modelClass)
  }
`);
